// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Tpl9VWiqXPMG-Eme63uET","button":"_3umUecQKGyVBwoXpnWIiSh","closeIcon":"_2Dpufv6eBxpW3zOQFG3BZv"};